import React from 'react';
import PropTypes from 'prop-types';
import {View, Link} from 'MWC';
import '../less/menuItem.less';
import classNames from 'classnames';

class MenuItem extends View {
    render() {
        const {alias, url, active, children, activeSub} = this.props,
            className = classNames(
                'module-header-menu-item',
                {
                    active: active === alias || activeSub === url
                },
                this.props.className
            );
        return (
            <Link className={className} href={url} onClick={this._handleClick}>
                <span className='header-menu-children'>{children}</span>
            </Link>
        );
    }

    _handleClick = e => {
        const {url} = this.props;

        if (this._shouldOpenInNewTab(url)) {
            e.preventDefault();
            window.open(url, '_blank');
            return;
        }

        this._handleNavigation(e);
        this._handleAdditionalActions();
    };

    _shouldOpenInNewTab = url => {
        return (
            url.endsWith('.pdf') ||
            url.includes('https://ab.a-bank.com.ua/') ||
            url.includes('transfer-bonus')
        );
    };

    _handleNavigation = e => {
        const {url, navigate} = this.props;

        if (url.endsWith('#frame') || url.endsWith('addcash') || url.endsWith('cashcomfort')) {
            window.location.href = url;
        } else {
            navigate(url, e);
        }
    };

    _handleAdditionalActions = () => {
        const {onClick, toggleHover, closeMenu, alias} = this.props;

        if (typeof onClick === 'function') {
            onClick();
        }

        if (toggleHover) {
            toggleHover(false, alias);
        }

        if (closeMenu) {
            closeMenu();
        }
    };

    static propTypes = {
        active: PropTypes.string,
        url: PropTypes.string,
        alias: PropTypes.string,
        navigate: PropTypes.func
    };

    static displayName = 'Header.Views.MenuItem';
}

export default MenuItem;
